import { Engine1Proxy, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';
//let atlasPath = "/ATLAS/General/";

let AtlasManager = function () {

    /**
     * Ejecuta la saga de Atlas
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {

        SagasProxy.AddSagaRequests(localValues, saga, "ATLAS", "ATLAS");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "ATLAS");
    }


    function _convertirFecha(valor) {
        
        let fechaAux = valor.split('-')
        let fecha1 = ""
        let dia = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0]
        let mes = fechaAux[1].length > 1 ? fechaAux[1] : "0" + fechaAux[1]
        fecha1 += mes + "-" + dia + "-" + fechaAux[2]

        return fecha1;
    }

    function mapearInstancia(data) {

        let localValues = {
            "ENTIDAD_INSTANCIA": {
                "Id": data.instancias[0].EntidadInstanciaId,
                "EntidadId": data.instancias[0].EntidadId,
                "EntidadCodigo": data.codigoEntidad,
                "Activo": data.instancias[0].Activo,
                "Propiedades": data.instancias.map((propiedad) => {
                    
                    return {
                        "Id": propiedad.PropiedadInstanciaId,
                        "PropiedadId": propiedad.PropiedadId,
                        "PropiedadCodigo": propiedad.Codigo,
                        "Valor": ((propiedad.TipoCodigo == 'DATETIME' && propiedad.Valor != null && propiedad.Valor != "") ? (_convertirFecha(propiedad.Valor)) 
                                                                                                                           : (propiedad.Obligatorio) ? (propiedad.Valor != null ?  propiedad.Valor.toString().trim() 
                                                                                                                                                                                : propiedad.Valor) 
                                                                                                                                                     : propiedad.Valor != null ? propiedad.Valor.toString().trim() 
                                                                                                                                                                               : ""),
                        "Equivalencias": ((propiedad.Codigo == "CODIGO") ? data.instanciaEquivalencias.map((insEqui) => {
                            let codigoEquivalencia = (!insEqui.CodigoEquivalencia
                                ? data.equivalencias.find((x) => x.Id == insEqui.IdEquivalencia).Codigo
                                : insEqui.CodigoEquivalencia);
                            
                            let subEquivalenciaId = data.requiereSubequivalencia ? insEqui.SubequivalenciaId : null;

                            return {
                                "Id": ((insEqui.IdEquivalenciaInstancia > 0) ? insEqui.IdEquivalenciaInstancia : null),
                                "EquivalenciaId": insEqui.IdEquivalencia,
                                "EquivalenciaCodigo": codigoEquivalencia,
                                "DeleteInstance": insEqui.DeleteInstance,
                                "Valor": insEqui.ValorEquivalencia,
                                "SubequivalenciaId": subEquivalenciaId,
                                "CodigoSubequivalencia": subEquivalenciaId ? insEqui.CodigoSubequivalencia : null
                            }
                        }) : null)
                    }

                })
            }
        }
        return localValues;
    }

    function _guardarInstancias(data, sagasCallback, viewCallback) {
        let localValues = mapearInstancia(data);

        ejecutarSagas(localValues, 'NOVEDAD_PARAMETRIA', sagasCallback, viewCallback);
    }

    //Funciones públicas
    return {
        GuardarInstancias: function (data, sagasCallback, viewCallback) {
            return _guardarInstancias(data, sagasCallback, viewCallback);
        }
    }
}

let atlasManager = new AtlasManager();
export default atlasManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Common/Managers/AtlasManager.js